import { Deserializable } from './deserializable';

export class ReferenceDataCodeValuePair implements Deserializable {
  public Code: string;
  public Value: string;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
